'use-strict';

import angular from 'angular';

import { ApiService } from '../../src/app/shared/services/api';
import { VehicleExportFrontendRequest } from '../../src/app/@shared-types/api/export-crud';

export class PlatformsAPIService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    'ngInject';

    this.apiService = apiService;
  }

  public publishVehicle = (
    req: VehicleExportFrontendRequest,
  ): Promise<void> => this.apiService.post<void>('/api/external-api/publish', req);
}

export default angular.module('services.platformsApiService', [])
  .service('platformsApiService', PlatformsAPIService)
  .name;
